function NotFound() {
    return (
        <>
        NotFound page
        </>
    )
}

export default NotFound;
